import { gql } from '@apollo/client';

export const GET_COLLATERAL_REPORT_URL = gql`
  mutation GetCollateralReportUrl($input: GetCollateralReportUrlInput!) {
    getCollateralReportUrl(input: $input) {
      url
      expiresAt
    }
  }
`;
